/**
 * @edusense/course-client
 * Course Server API 클라이언트 패키지
 */

// 생성된 API 클라이언트 re-export (user-client와 동일한 패턴)
export * from './client_gen_gen_generated/roadmap';
export * from './client_gen_gen_generated/course';
export * from './client_gen_gen_generated/course-search';
export * from './client_gen_gen_generated/course-draft';
export * from './client_gen_gen_generated/enrollment';
export * from './client_gen_gen_generated/review';
export * from './client_gen_gen_generated/types';

// 명시적 export로 Rollup 빌드 에러 해결
export { useUploadLectureResource } from './client_gen_gen_generated/course';
export { useGetRoadmapsInfinite } from './client_gen_gen_generated/roadmap';
export { useGetApiCoursesInfinite } from './client_gen_gen_generated/course-search';
export { useGetApiCoursesCourseIdLecturesLectureId as useGetLectureDetail } from './client_gen_gen_generated/course';
export { getGetApiCoursesCourseIdLecturesLectureIdQueryKey } from './client_gen_gen_generated/course';
export { GetApiCoursesType } from './client_gen_gen_generated/types/getApiCoursesType';
